import type { ProviderPriceListItemOptionModel } from '@models/types'
import { EntitiesState } from '@redux/entities'

type FilterPriceListItemOptionValuesByOptionParams = {
  providerPriceListItemOption: ProviderPriceListItemOptionModel | { id?: number },
  providerPriceListItemOptionValues: EntitiesState['providerPriceListItemOptionValues'],
}

const filterPriceListItemOptionValuesByOption = (params: FilterPriceListItemOptionValuesByOptionParams) => {
  const { providerPriceListItemOption, providerPriceListItemOptionValues } = params

  if (!providerPriceListItemOption?.id){
    return []
  }

  const filtered = Object.values(providerPriceListItemOptionValues)
    .filter((providerPriceListItemOptionValue) => {
      const { hidden, provider_price_list_item_option_id } = providerPriceListItemOptionValue

      return !hidden
        && providerPriceListItemOption.id === provider_price_list_item_option_id
    })

  const sorted = filtered.sort((a, b) => {
    // For old option values that have no sort assigned yet, sort by price
    if (a.sort !== undefined && b.sort !== undefined){
      return a.sort - b.sort
    }

    return a.price - b.price
  })

  return sorted
}

export default filterPriceListItemOptionValuesByOption
